module.exports = __webpack_public_path__ + "img/ndaytrip_mt.3c32d866.png";